var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCode = function SvgIconCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14 1h2a3 3 0 0 1 3 3v2M6 1H4a3 3 0 0 0-3 3v2m13 13h2a3 3 0 0 0 3-3v-2M6 19H4a3 3 0 0 1-3-3v-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M14.5 5v10m-3-10v10m-3-10v10m-3-10v10"
  })));
};
export { SvgIconCode as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDFIMTZDMTcuNjU2OSAxIDE5IDIuMzQzMTUgMTkgNFY2TTYgMUg0QzIuMzQzMTUgMSAxIDIuMzQzMTUgMSA0VjZNMTQgMTlIMTZDMTcuNjU2OSAxOSAxOSAxNy42NTY5IDE5IDE2VjE0TTYgMTlINEMyLjM0MzE1IDE5IDEgMTcuNjU2OSAxIDE2VjE0IiBzdHJva2U9IiMxRDFEMUQiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjUgNUwxNC41IDE1TTExLjUgNUwxMS41IDE1TTguNSA1TDguNSAxNU01LjUgNUw1LjUgMTUiIHN0cm9rZT0iIzFEMUQxRCIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";